import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import SegmentsController from './segments.controller';
import { Button } from 'antd';
import { Layers, Plus } from 'lucide-react';

import { Layout, TableSkeleton, AnalyticsSkeleton, PageHeader } from '../common';
import { SegmentTable, SegmentAnalytics } from './elements';
import withNavigate from '../../core/withNavigate';

export class ShelfSegments extends Inherit(SegmentsController, Component) {
    state = {
        loading: true,
        storeTypes: [],
        rows: [],
        search: '',
        suggestions: []
    };

    render() {
        const { loading, storeTypes, rows, search, suggestions } = this.state;

        return (
            <Layout current="segments">
                <PageHeader
                    icon={<Layers />}
                    title="Segmentaciones de Productos"
                    description="Configura qué productos se auditan en cada tipo de piso de venta"
                    actions={
                        <Button type="primary" icon={<Plus />} onClick={() => this.navigateSegmentList('')}>
                            Crear Nueva Segmentación
                        </Button>
                    }
                />

                {loading ? (
                    <div className="space-y-4">
                        <AnalyticsSkeleton count={3} />
                        <TableSkeleton rows={8} columns={5} />
                    </div>
                ) : (
                    <div className="space-y-4">
                        <SegmentAnalytics storeTypes={storeTypes} />

                        <SegmentTable
                            rows={rows}
                            loading={loading}
                            storeTypes={storeTypes}
                            search={search}
                            suggestions={suggestions}
                            onSearch={this.searchSegments.bind(this)}
                            onSearchChange={this.setSearch.bind(this)}
                            navigateSegmentList={this.navigateSegmentList.bind(this)}
                        />
                    </div>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfSegments);
